import React from "react";
import "./table.scss";

/**
 * Functional component to return the barebones table structure
 */
function Table(props) {
    return (
        <table className={["ui-table", props.className].join(" ")}>
            {/* Table headings */}
            <thead>
                <tr>
                    {props.headings.map((heading, index) => {
                        const headingConfig = typeof heading === "string" ? { label: heading } : heading;
                        const isSortable = !!headingConfig.sortable;

                        return (
                            <th key={headingConfig.key || index}>
                                {isSortable ? (
                                    <button
                                        type="button"
                                        className={[
                                            "ui-table-heading-sort",
                                            headingConfig.active && "is-active",
                                            headingConfig.direction && `is-${headingConfig.direction}`,
                                        ].filter(Boolean).join(" ")}
                                        onClick={headingConfig.onClick}>
                                        <span>{headingConfig.label}</span>
                                        <span className="ui-table-sort-arrows" aria-hidden="true">
                                            <span className="ui-table-sort-arrow is-up" />
                                            <span className="ui-table-sort-arrow is-down" />
                                        </span>
                                    </button>
                                ) : (
                                    headingConfig.label
                                )}
                            </th>
                        );
                    })}
                </tr>
            </thead>

            {/* Table rows */}
            <tbody>
                {/* Are there results to print? */}
                {!props.noResults && props.children}

                {/* If there are no results to print */}
                {props.noResults &&
                    <tr>
                        <td colSpan={props.headings.length}>
                            <small>{props.noResultsMessage}</small>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    );
}

export default Table;